import { render } from "./AlertManager.vue?vue&type=template&id=f291f5bc"
import script from "./AlertManager.vue?vue&type=script&lang=js"
export * from "./AlertManager.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__